<ng-container *ngIf="isLoading$ | async">
  <div class="progress progress-modal">
    <div class="progress-bar progress-bar-striped progress-bar-animated bg-primary" role="progressbar"
      style="width: 100%" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
  </div>
</ng-container>
<ngx-spinner></ngx-spinner>

<div  class="text-center" style="padding: 15px;">
  <div class="row" style="margin: 30px 0px 20px 0px;">
    <div class="col-lg-12">
      <h3>{{ language == 'en'? "Book new appointment": " حجز موعد جديد" }}</h3>
    </div>
  </div>
  
  <div mat-dialog-content style="margin-top: 10px">
    <!-- <div style="margin-bottom: 20px;">
      <label>{{ language == 'en'? "Choose appointment type": "اختر نوع الحجز" }}</label><br>
      <input style="margin: 10px;" name="MeetingType"  type="radio" [value]="2"  [(ngModel)]="MeetingType" >{{ language == 'en'? "Online": "عبر الانترنت" }}
      <input style="margin: 10px;" name="MeetingType" type="radio" [value]="1" [(ngModel)]="MeetingType" >{{ language == 'en'? "At the clinic": "داخل العيادة" }}
    </div> -->
    <p >{{ language == 'en'? "Are you sure to book this appointment?": "هل انت متأكد من حجز هذا الموعد؟" }}</p><br>
    <div class="badge bg-success">{{Slot.fromTime | date:'shortTime':'UTC' }}</div>
  </div>
  <div class="text-center" style="margin-top: 30px;">
    <div class="col-lg-12">
      <div class="text-center">
        <button style="font-weight: bold;" type="button" class="btn btn-success" (click)="ConfirmSaveAppointment()">{{
          'COMMON.YES' |
          translate }}</button>
        <button type="button" style="margin: 10px;font-weight: bold;" class="btn btn-danger" (click)="onNoClick()">{{
          'COMMON.NO' |
          translate }}</button>
        <br>
        <ng-container *ngIf="isLoading$ | async">
          <div class="spinner-border" role="status" style="margin-top: 30px;">
            <span class="visually-hidden"></span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>